<div>
  <small class="debug">{{me}}</small>
  <div class="cardInner">
    <br/>
    <div>
      @if (dynamicsInitialized) {
        <div>
          <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
          </dynamic-form>
        </div>
      }
    </div>
  </div>
  <br/>
  <br/>
  <br/>
  <br/>
</div>
